import React from "react";
import ReactPlayer from "react-player";
import * as S from "./styles";

export const Slide6: React.FC = () => {
  return (
    <S.Container>
      <S.Content className="left">
        <S.Wrapper>
          <S.Title>
            Avril Lavigne <span>-</span>
            <br /> Sk8er Boi
          </S.Title>
          <S.Video>
            <ReactPlayer
              className="react-player"
              width="100%"
              height="100%"
              url="https://www.youtube.com/watch?v=TIy3n2b7V9k"
            />
          </S.Video>
        </S.Wrapper>
      </S.Content>
      <S.Content className="right">
        <S.ContentWrapper>
          <S.Name>Mahmundi</S.Name>
          <S.Profile>Cantora</S.Profile>
          <S.Text>
            “‘Sk8er boi’, da Avril Lavigne. Me lembro de, a caminho da escola,
            passar por uma banca e chapar quando vi aquela menina de gravata e
            boné na capa de uma revista. Não fazia ideia de quem era! Foi na
            época que Britney Spears e Christina Aguilera, e todas aquelas
            garotas com as quais eu não me identificava, faziam sucesso. Dias
            depois, vi o clipe na casa de uns amigos e pirei: era a menina da
            revista! O vídeo é uma convocação para um show no meio da rua e me
            dava uma sensação de liberdade muito forte. Adoro a parte final,
            quando a polícia chega e ela aparece com o cabelo esvoaçante. Achava
            muito rockstar. Amo a Avril Lavigne. Ela foi uma das artistas que me
            inspirou a fazer música.”
          </S.Text>
        </S.ContentWrapper>
      </S.Content>
    </S.Container>
  );
};
